import z from 'zod';

import type { QcsResourceSlice } from '../core/resourceSliceUtils';
import { MileageTrackerAddressSchema } from '../mileage-tracker-address/mileageTrackerAddressTypes';
import { MileageTrackerPurposeSchema } from '../mileage-tracker-purpose/mileageTrackerPurposeTypes';

export const MILEAGE_TRACKER_REDUCER_KEY = 'mileageTrackerStore';
export type MILEAGE_TRACKER_REDUCER_KEY = typeof MILEAGE_TRACKER_REDUCER_KEY;

export const CURRENT_YEAR_MILEAGE_FALLBACK = 0.7;

export enum MileageTripType {
  MilesOnly = 'MILES_ONLY',
  TripDetails = 'TRIP_DETAILS',
  UNKNOWN = 'UNKNOWN',
}

const mileageTypeSchema = z.enum([MileageTripType.MilesOnly, MileageTripType.TripDetails, MileageTripType.UNKNOWN]);

export type MileageTypeSchema = z.infer<typeof mileageTypeSchema>;

export const MileageTrackerSchema = z.object({
  id: z.string().optional(),
  type: mileageTypeSchema,
  clientId: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
  postedOn: z.string().optional(),
  vehicleId: z.string().optional(),
  startAddress: MileageTrackerAddressSchema.nullable().optional(),
  endAddress: MileageTrackerAddressSchema.nullable().optional(),
  startAddressId: z.string().nullable().optional(),
  endAddressId: z.string().nullable().optional(),
  milesTraveled: z.number(),
  value: z.number().optional(),
  isRoundtrip: z.boolean(),
  businessId: z.string().optional(),
  purpose: MileageTrackerPurposeSchema.optional(),
  notes: z.string().optional(),
});

export type MileageTrackerType = z.infer<typeof MileageTrackerSchema>;

export type MileageTrackerState = QcsResourceSlice<MileageTrackerType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [MILEAGE_TRACKER_REDUCER_KEY]: MileageTrackerState;
  }
}
